/*
 * ShiftsForm Messages
 *
 * This contains all the text for the ShiftsForm component.
 */

import { defineMessages } from 'react-intl';

export const scope =
  'src.pages.ProjectDetailsPage.components.JobList.components.ShiftsForm';

export default defineMessages({
  dateLabel: {
    id: `${scope}.dateLabel`,
    defaultMessage: 'Date',
  },
  quantityLabel: {
    id: `${scope}.quantityLabel`,
    defaultMessage: 'Quantity',
  },
  startTimeLabel: {
    id: `${scope}.startTimeLabel`,
    defaultMessage: 'Start Time',
  },
  endTimeLabel: {
    id: `${scope}.endTimeLabel`,
    defaultMessage: 'End Time',
  },
  deleteShiftConfirmMessage: {
    id: `${scope}.deleteShiftConfirmMessage`,
    defaultMessage: 'Are you sure you want to delete this Shift?',
  },
  saveButton: {
    id: `${scope}.saveButton`,
    defaultMessage: 'Save shift',
  },
  saveShiftButton: {
    id: `${scope}.saveShiftButton`,
    defaultMessage: 'Save',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  addButton: {
    id: `${scope}.addButton`,
    defaultMessage: 'Add shift',
  },
  shiftListLabel: {
    id: `${scope}.shiftListLabel`,
    defaultMessage: 'Shift List',
  },
});
